export default __webpack_public_path__ + "static/Whip-21e01771fc2710bc5b1313c66c65e0d4.png";